import styled from '@emotion/styled'

import { Button1 } from './Button1'

export const Button4 = styled(Button1)({
  fontSize: '0.75rem', // 12px
})
